(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-header-rebuild"]) return;
  try {
    
(() => {
  const init = (header) => {
    if (header.dataset.smInitialized === 'true') return;
    header.dataset.smInitialized = 'true';

    const shop = header.querySelector('[data-sm-shop]');
    const roots = [...header.querySelectorAll('[data-sm-root]')];
    const rootPanels = [...header.querySelectorAll('[data-sm-root-panel]')];
    const children = [...header.querySelectorAll('[data-sm-child]')];
    const childPanels = [...header.querySelectorAll('[data-sm-child-panel]')];
    const canHover = window.matchMedia('(hover: hover)').matches;

    const activateChild = (key) => {
      children.forEach((button) => {
        const active = button.dataset.smChild === key;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      childPanels.forEach((panel) => {
        panel.hidden = panel.dataset.smChildPanel !== key;
      });
    };

    const activateRoot = (key) => {
      roots.forEach((button) => {
        const active = button.dataset.smRoot === key;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      let activePanel = null;
      rootPanels.forEach((panel) => {
        const active = panel.dataset.smRootPanel === key;
        panel.hidden = !active;
        if (active) activePanel = panel;
      });

      const firstChild = activePanel?.querySelector('[data-sm-child]');
      if (firstChild) activateChild(firstChild.dataset.smChild);
    };

    roots.forEach((button) => {
      button.addEventListener('click', () => activateRoot(button.dataset.smRoot));
      button.addEventListener('focus', () => activateRoot(button.dataset.smRoot));
      if (canHover) button.addEventListener('mouseenter', () => activateRoot(button.dataset.smRoot));
    });

    children.forEach((button) => {
      button.addEventListener('click', () => activateChild(button.dataset.smChild));
      button.addEventListener('focus', () => activateChild(button.dataset.smChild));
      if (canHover) button.addEventListener('mouseenter', () => activateChild(button.dataset.smChild));
    });

    if (shop) {
      document.addEventListener('click', (event) => {
        if (shop.open && !shop.contains(event.target)) shop.removeAttribute('open');
      });

      shop.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && shop.open) {
          shop.removeAttribute('open');
          shop.querySelector('summary')?.focus();
        }
      });
    }

    const openButton = header.querySelector('[data-sm-mobile-open]');
    const drawer = header.querySelector('[data-sm-mobile-drawer]');
    const visibleHeader = header.querySelector('.header__grid');
    const mobilePanel = header.querySelector('[data-sm-mobile-panel]');
    const mobileScreens = [...header.querySelectorAll('[data-sm-mobile-screen]')];
    const mobileRootButtons = [...header.querySelectorAll('[data-sm-mobile-root]')];
    const mobileChildButtons = [...header.querySelectorAll('[data-sm-mobile-child]')];
    const mobileBackButtons = [...header.querySelectorAll('[data-sm-mobile-back]')];

    const syncDrawerTop = () => {
      if (!drawer || !visibleHeader || drawer.hidden) return;
      const rect = visibleHeader.getBoundingClientRect();
      drawer.style.setProperty('--sm-mobile-drawer-top', Math.max(0, rect.bottom) + 'px');
    };

    const showMobileScreen = (key, focusTarget = null) => {
      mobileScreens.forEach((screen) => {
        screen.hidden = screen.dataset.smMobileScreen !== key;
      });

      if (mobilePanel) {
        mobilePanel.scrollTop = 0;
      }

      requestAnimationFrame(() => {
        if (focusTarget) focusTarget.focus({ preventScroll: true });
      });
    };

    const setDrawer = (open) => {
      if (!drawer || !openButton) return;

      drawer.hidden = !open;
      openButton.setAttribute('aria-expanded', open ? 'true' : 'false');
      openButton.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');

      if (open) {
        showMobileScreen('root');
        requestAnimationFrame(syncDrawerTop);
        document.documentElement.style.overflow = 'hidden';
      } else {
        drawer.style.removeProperty('--sm-mobile-drawer-top');
        document.documentElement.style.overflow = '';
      }
    };

    mobileRootButtons.forEach((button) => {
      button.addEventListener('click', () => {
        showMobileScreen('root-' + button.dataset.smMobileRoot);
      });
    });

    mobileChildButtons.forEach((button) => {
      button.addEventListener('click', () => {
        showMobileScreen('child-' + button.dataset.smMobileChild);
      });
    });

    mobileBackButtons.forEach((button) => {
      button.addEventListener('click', () => {
        showMobileScreen(button.dataset.smMobileBack);
      });
    });

    openButton?.addEventListener('click', () => {
      setDrawer(openButton.getAttribute('aria-expanded') !== 'true');
    });

    window.addEventListener('resize', syncDrawerTop);
    window.addEventListener('orientationchange', syncDrawerTop);

    header.querySelector('[data-sm-supplymate]')?.addEventListener('click', (event) => {
      event.preventDefault();

      if (shop?.open) {
        shop.removeAttribute('open');
      }

      window.dispatchEvent(new CustomEvent('supplymate:open', {
        detail: { source: 'header-mega-menu' }
      }));
    });
  };

  const boot = () => document.querySelectorAll('[data-sm-header]').forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
